/** The organization's binary files (the sound library), as one load that all its readers share. */

import { atom } from 'jotai';

import { snapshotAtoms } from '../snapshotAtoms';
import { api } from '@/api';
import type { BinaryFilesSnapshot } from '@/types/binaryFiles';
import { type StreamInput, StreamInputKind } from '@/types/notifications';

const PENDING: BinaryFilesSnapshot = {
    files: [],
    isLoading: true,
    error: null,
};

const binaryFiles = snapshotAtoms<BinaryFilesSnapshot>(PENDING, async () => {
    return {
        files: await api.listBinaryFiles(),
        isLoading: false,
        error: null,
    };
});

export const binaryFilesAtom = binaryFiles.value;
export const refreshBinaryFilesAtom = binaryFiles.reload;

/** What the notifications stream means for the binary files. */
export const binaryFilesStreamAtom = atom(null, (_get, set, input: StreamInput): void => {
    if (input.kind === StreamInputKind.Reopened) {
        set(refreshBinaryFilesAtom);
        return;
    }
    if (input.kind === StreamInputKind.Frame && input.frame.type === 'change' &&
        input.frame.resource === 'binary_files') {
        set(refreshBinaryFilesAtom);
    }
});
